<template>
  <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 xl:grid-cols-5 gap-4">
    <!-- Online Agents -->
    <div class="relative overflow-hidden rounded-xl bg-n-slate-2 dark:bg-n-slate-3 border border-n-slate-6 dark:border-n-slate-7 p-6 shadow-sm hover:shadow-lg hover:-translate-y-1 hover:scale-[1.02] transition-all duration-300 ease-out cursor-default">
      <div class="flex items-center justify-between">
        <div>
          <p class="text-xs font-medium uppercase tracking-wider text-n-slate-11 dark:text-n-slate-11">
            Agentes Ativos 
          </p>
          <p class="mt-2 text-3xl font-bold text-n-teal-11 dark:text-n-teal-10">
            {{ metrics.online_agents }}
          </p>
          <p class="mt-1 text-xs text-n-slate-10 dark:text-n-slate-10">
            de {{ metrics.total_agents }} total
          </p>
        </div>
        <div class="text-4xl opacity-30">🟢</div>
      </div>
    </div>

    <!-- Open Conversations -->
    <div class="relative overflow-hidden rounded-xl bg-n-slate-2 dark:bg-n-slate-3 border border-n-slate-6 dark:border-n-slate-7 p-6 shadow-sm hover:shadow-lg hover:-translate-y-1 hover:scale-[1.02] transition-all duration-300 ease-out cursor-default">
      <div class="flex items-center justify-between">
        <div>
          <p class="text-xs font-medium uppercase tracking-wider text-n-slate-11 dark:text-n-slate-11">
            Abertas
          </p>
          <p class="mt-2 text-3xl font-bold text-n-blue-11 dark:text-n-blue-10">
            {{ formatNumber(metrics.open_conversations) }}
          </p>
          <p class="mt-1 text-xs text-n-slate-10 dark:text-n-slate-10">
            conversas ativas
          </p>
        </div>
        <div class="text-4xl opacity-30">💬</div>
      </div>
    </div>

    <!-- Pending Conversations -->
    <div class="relative overflow-hidden rounded-xl bg-n-slate-2 dark:bg-n-slate-3 border border-n-slate-6 dark:border-n-slate-7 p-6 shadow-sm hover:shadow-lg hover:-translate-y-1 hover:scale-[1.02] transition-all duration-300 ease-out cursor-default">
      <div class="flex items-center justify-between">
        <div>
          <p class="text-xs font-medium uppercase tracking-wider text-n-slate-11 dark:text-n-slate-11">
            Pendentes
          </p>
          <p class="mt-2 text-3xl font-bold text-n-amber-11 dark:text-n-amber-10">
            {{ formatNumber(metrics.pending_conversations) }}
          </p>
          <p class="mt-1 text-xs text-n-slate-10 dark:text-n-slate-10">
            aguardando resposta
          </p>
        </div>
        <div class="text-4xl opacity-30">⏱️</div>
      </div>
    </div>

    <!-- Total Assignments -->
    <div class="relative overflow-hidden rounded-xl bg-n-slate-2 dark:bg-n-slate-3 border border-n-slate-6 dark:border-n-slate-7 p-6 shadow-sm hover:shadow-lg hover:-translate-y-1 hover:scale-[1.02] transition-all duration-300 ease-out cursor-default">
      <div class="flex items-center justify-between">
        <div>
          <p class="text-xs font-medium uppercase tracking-wider text-n-slate-11 dark:text-n-slate-11">
            Atribuições
          </p>
          <p class="mt-2 text-3xl font-bold text-n-iris-11 dark:text-n-iris-10">
            {{ formatNumber(metrics.total_assignments) }}
          </p>
          <p class="mt-1 text-xs text-n-slate-10 dark:text-n-slate-10">
            no período
          </p>
        </div>
        <div class="text-4xl opacity-30">📊</div>
      </div>
    </div>

    <!-- Reassignments -->
    <div class="relative overflow-hidden rounded-xl bg-n-slate-2 dark:bg-n-slate-3 border border-n-slate-6 dark:border-n-slate-7 p-6 shadow-sm hover:shadow-lg hover:-translate-y-1 hover:scale-[1.02] transition-all duration-300 ease-out cursor-default">
      <div class="flex items-center justify-between">
        <div>
          <p class="text-xs font-medium uppercase tracking-wider text-n-slate-11 dark:text-n-slate-11">
            Redistribuições
          </p>
          <p class="mt-2 text-3xl font-bold text-n-ruby-11 dark:text-n-ruby-10">
            {{ formatNumber(metrics.reassignments) }}
          </p>
          <p class="mt-1 text-xs text-n-slate-10 dark:text-n-slate-10">
            manuais
          </p>
        </div>
        <div class="text-4xl opacity-30">🔄</div>
      </div>
    </div>


    <!-- Resolved Conversations -->
    <div class="relative overflow-hidden rounded-xl bg-n-slate-2 dark:bg-n-slate-3 border border-n-slate-6 dark:border-n-slate-7 p-6 shadow-sm hover:shadow-lg hover:-translate-y-1 hover:scale-[1.02] transition-all duration-300 ease-out cursor-default">
      <div class="flex items-center justify-between">
        <div>
          <p class="text-xs font-medium uppercase tracking-wider text-n-slate-11 dark:text-n-slate-11">
            Resolvidas
          </p>
          <p class="mt-2 text-3xl font-bold text-n-teal-11 dark:text-n-teal-10">
            {{ formatNumber(metrics.resolved_conversations) }}
          </p>
          <p class="mt-1 text-xs text-n-slate-10 dark:text-n-slate-10">
            no período
          </p>
        </div>
        <div class="text-4xl opacity-30">🎉</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MetricsCards',
  props: {
    metrics: {
      type: Object,
      required: true,
    },
  },
  methods: {
    formatNumber(num) {
      return num?.toLocaleString() || '0';
    },
    formatTime(seconds) {
      if (!seconds || seconds === 0) return '0s';

      const totalSeconds = Math.round(seconds);
      
      const days = Math.floor(totalSeconds / 86400);
      const hours = Math.floor((totalSeconds % 86400) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const secs = totalSeconds % 60;

      // ✅ Se for mais de 1 dia
      if (days > 0) {
        return hours > 0 ? `${days}d ${hours}h` : `${days}d`;
      }
      
      // ✅ Se for mais de 1 hora
      if (hours > 0) {
        return minutes > 0 ? `${hours}h ${minutes}min` : `${hours}h`;
      }
      
      // ✅ Se for mais de 1 minuto
      if (minutes > 0) {
        return secs > 0 ? `${minutes}min ${secs}s` : `${minutes}min`;
      }
      
      // ✅ Apenas segundos
      return `${secs}s`;
    },
  },
};
</script>